<template>
  <section class="app-main">
    <router-view v-slot="{ Component, route }">
      <transition name="fade-transform" mode="out-in">
        <keep-alive :include="tagsViewStore.cachedViews">
          <component v-if="!route.meta.link" :is="Component" :key="route.fullPath"/>
        </keep-alive>
      </transition>
    </router-view>
    <iframe-toggle />
  </section>
</template>

<script setup>
import iframeToggle from "./IframeToggle/index"
import useTagsViewStore from '@/store/modules/tagsView'

const tagsViewStore = useTagsViewStore()
</script>

<style lang="scss">
.app-main {
  --header-height: 50px;
  --view-top: 0;
  /* 50= navbar  50  */

  min-height: 100vh;
  height: auto;
  width: 100%;
  position: relative;
  //overflow: hidden;
  // 过度用后需要改为hidden todo
  overflow: auto;
  //>.app-container{
    box-shadow: 1px 0 4px 2px var(--el-box-shadow-light-color) inset;
  //}
}

.fixed-header + .app-main {
  padding-top: var(--view-top);
  //height: calc(100vh - var(--view-top));
  height: 100vh
}

.hasTagsView {
  --header-height: 88px;
  .app-main {
    --view-top:0px;
    --header-height: 88px;
    /* 88 = navbar + tags-view = 50 + 38 */
    min-height: calc(100vh - var(--header-height));
    //height: calc(100vh - var(--header-height));

  }

  .fixed-header + .app-main {
    --view-top:var(--header-height);
    padding-top: var(--header-height);
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 6px;
  }
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c0c0c0;
  border-radius: 3px;
}
</style>

